export default {"src":"/_next/static/media/ic-notice.ec3200a2.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};